const AVEDA_FRANCHISE_THEME = {
  // We use this to avoid importing ANY code that requires i18n translation as that
  // provider then includes the franchise theme/config provider, which ultimately creates
  // a circular dependency
  //
  // TODO: Find a better way to handle this without breaking the dev tools language/theme switcher!
  avedaHeaderHack: true,

  colors: {
    primary: "#687233",
    primaryAccent: "#FFF",

    secondary: "#120E02",
    secondaryAccent: "#FFF",

    tertiary: "#F4F2EE",

    accent: "#BC3C3C",
    error: "#BC3C3C",

    headers: "#120E02",
    price: "#120E02",

    lightHover: "#F4F2EE",
    darkHover: "rgb(244, 242, 238)",

    overlayColor: "rgba(0, 0, 0, 0.8)",
  },
  sideNav: {
    top: "81px",
    alignment: "left",
    background: "rgb(244, 242, 238)",
    links: "#120E02",
    activeLinks: "#687233",
    legalLinks: "#120E02",
  },
  topNav: {
    background: "#FFF",
    links: "#120E02",
    whatWhenWhereText: "#120E02",
  },
  dateSelector: {
    defaultText: "#120E02",
    selectedText: "#120E02",
    selectedBackground: "#D1D2BF",
  },
  timeSelector: {
    defaultText: "#120E02",
    selectedText: "#120E02",
    selectedBackground: "#D1D2BF",
  },
  button: {
    borderRadius: "0px",
    borderWidth: "1px",
    textTransform: "uppercase",
    letterSpacing: "1px",
    fontWeight: "normal",
    fontSizeSmall: "13px",
    fontSizeLarge: "15px",
  },
  paymentMethod: {
    backgroundColor: "#000",
  },
  poweredByFlossie: {
    backgroundColor: "#000",
  },

  pageMaxWidth: "1200px",
  instantBookMaxWidth: "1200px",

  wwwBgImageSize: "cover",
  wwwBgImage: require("../../assets/images/aveda-bg.jpg"),
  wwwBgImageBlendMode: "multiply",
  wwwBgColor: "transparent",
  wwwBgImagePosition: "center center",
  wwwBgImagePositionMobile: "center center",

  globalStyles: (theme) => `
  `,
}

export default AVEDA_FRANCHISE_THEME
